import { CascaderOptionType } from "antd/lib/cascader";
import { ModelBase } from "./ModelBase";

export enum TipoCategoriaIns {
    Manual = 0,
    ML
}

export enum SorgenteType {
    Excel = 0,
    Provider
}


export class Movimento extends ModelBase {
    Data: Date
    Importo: number
    Descrizione: string
    ContoCorrente: string
    Categoria: string
    Categorie: string[] // Devono essere gli id delle categorie selezionate
    TipoCosto: string
    TipoInserimentoCategoria: TipoCategoriaIns
    Sorgente: SorgenteType
}

export class Saldo {
    Id: string
    Periodo: Date
    ContoCorrente: string
    ContoCorrenteId: string
    Saldo: number
}

export class RaccoltaDatiInputModel extends ModelBase {
    Fatturato: number
    Crediti: number
    CreditiNonSaldati?: number
    Debiti: number
    DebitiNonSaldati?: number
    ConfigFatturazione:boolean
    Periodo: Date
}

export class RaccoltaDatiModel extends RaccoltaDatiInputModel {
    Incassato: number
    Saldi: Array<Saldo>
    Uscite: Array<Movimento>
    Entrate: Array<Movimento>
}

export class MovimentoEditModel extends Movimento {
    CategoriaOptions: Array<CascaderOptionType>
}

export class ImportYapilyMovimentiModel {
    Periodo: Date
    ClienteId:string
}